<template>
    <v-card :loading="loading">
        <v-card-title class="text-h5">Restore Invoice</v-card-title>
        <v-card-text>
            Are you sure you want to restore this invoice?
        </v-card-text>
        <v-card-actions>
            <v-btn text color="error" @click="close">
                Cancel
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
                @click="restoreInvoice"
                text
                color="primary"
                :loading="loading"
            >
                Restore
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapMutations } from 'vuex'
import API from '@/services/api'
export default {
    name: 'RestoreInvoice',
    props: {
        invoice: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        loading: false,
    }),
    methods: {
        ...mapMutations(['setErrorItems']),
        close() {
            this.$emit('close')
        },
        async restoreInvoice() {
            try {
                this.loading = true
                await API.restoreInvoice({
                    id: this.invoice.id,
                    projectId:
                        this.invoice.type && this.invoice.type == 'proforma'
                            ? this.invoice.proformaProject
                            : this.invoice.projectId,
                })
                this.$emit('removeInvoice')
                this.close()
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
    },
}
</script>

<style></style>
